import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";

import FormSpinner from "../../../components/Spinners/FormSpinner";
import { fetchProducer, getConnectionData, getProducer } from "../modules/B2B";
import constant from "../../../helpers/constant";
import ProducerSearchBar from "./ProducerSearchBar";
import ReactPaginate from "react-paginate";
import ConnectionModal from "../../../components/ConnectionModals/ConnectionModal";
import { acceptRejectRequestWithVisitorId, followUnfollowUser } from "../../NetworkConnection/modules/networkConnection";
import auth from "../../../helpers/auth";
import language from "../../../helpers/language";
import CustomUseEffect from "../../../components/constants";

export default function ProducerSearch() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [heroca, setHeroca] = useState("");
  const [hubsId, setHubsId] = useState("");
  const [userName, setUserName] = useState("");
  const [productType, setProductType] = useState("");
  const [importerRoleId, setImporterRoleId] = useState([]);
  const [privateLabel, setPrivateLabel] = useState("");
  const [roleSearchType, setroleSearchType] = useState(2);
  const [alyseiBrandLabel, setAlyseiBrandLabel] = useState("");
  const [userId, setUserId] = useState("");
  const [page, setPage] = useState(1);
  const [isTrue, setIsTrue] = useState(false);
  const [isChange, setIsChange] = useState(false);
  const [openConnectionModel, setOpenConnectionModel] = useState(false);
  const [userPercenatge, setProfilePercentage] = useState('');
  const [typeOfUser, setTypeOfUser] = useState("");
  const [lang] = useState(language.getLang());
  const [hubShow, setHubShow] = useState(true);

  const { producerSpinner, getProducerData } = useSelector((state) => state.b2bState);
  const { profileData: { data } } = useSelector((state) => state.memberProfileData);

  CustomUseEffect(async () => {
    await setProfilePercentage(parseInt(localStorage.getItem("profile_percentage")));
    await getProducerSearch(page);
    const userType = await auth.getUserType()
    await setTypeOfUser(JSON.parse(userType))
    await setIsTrue(true);
  }, []);

  const getProducerSearch = async (pageNo) => {
    const producer = {
      searchType: roleSearchType,
      roleId: importerRoleId && importerRoleId.length ? importerRoleId : constant.rolesId.producer,
      hubsId: hubsId,
      heroca: heroca,
      productType: productType,
      privateLabel: privateLabel,
      alyseiBrandLabel: alyseiBrandLabel,
      page: !pageNo ? page : pageNo
    };

    await dispatch(fetchProducer(producer));
  };

  const handlePageClick = async (e) => {
    await setIsChange(true);
    let pageNo = e.selected + 1
    await setPage(page);
    await getProducerSearch(pageNo);
  };
  const handleCancelReq = async (userId, roleId) => {
    const newdata = getProducerData?.data?.data?.map((item) => item.user_id === userId ? { ...item, connection_flag: 0 } : item);
    const finalValue = {
      ...getProducerData,
      data: { ...getProducerData.data, data: newdata }
    }
    const response = await dispatch(acceptRejectRequestWithVisitorId({ connection_id: parseInt(userId), accept_or_reject: 3 }));
    if (response?.success === 200) {
      await dispatch(getProducer(finalValue));
      typeOfUser?.role_id === roleId && await dispatch(getConnectionData(finalValue));
    }
  }
  const handleConnectionModel = async (item) => {
    setUserName(item?.company_name ?? item.restaurant_name);
    setUserId(item.user_id);
    setOpenConnectionModel(!openConnectionModel);
  }
  const handleModal = async (newValue) => {
    await setOpenConnectionModel(newValue);

  }

  const followUser = async (user) => {
    const respone = await dispatch(followUnfollowUser({ follow_user_id: user.user_id, follow_or_unfollow: user.follow_flag === 0 ? 1 : 0 }));
    if (respone?.success === 200) {
      const newdata = getProducerData?.data?.data?.map((item) => item.user_id === user.user_id ? { ...item, follow_flag: user.follow_flag === 0 ? 1 : 0 } : item);
      const finalValue = {
        ...getProducerData,
        data: { ...getProducerData.data, data: newdata }
      }
      await dispatch(getProducer(finalValue));

    } else {
      console.log(respone);
    }
  }

  const getStatesOfSearchBar = async (filters) => {
    //console.log(filters,"selected filters"); 
    await setroleSearchType(filters.searchType);
    await setHubsId(filters.hubsId);
    await setHeroca(filters.heroca);
    await setProductType(filters.productType);
    await setPrivateLabel(filters.privateLabel);
    await setAlyseiBrandLabel(filters.alyseiBrandLabel);
  }

  return (
    <div className="servics_blocks">
      {/* {console.log(typeOfUser?.role_id,)} */}
      <div className="site-align top-align">
        {/* Left Block */}
        <ProducerSearchBar hubShow={hubShow} getStatesOfSearchBar={getStatesOfSearchBar} />
        {/* Middle long Block */}
        <div className="servics_blocks middle-long__section-block middleBlockBg">
          {openConnectionModel && <ConnectionModal openModelData={{ openModel: openConnectionModel, user_id: userId, name: userName, handleOpenModel: handleModal, type: constant.rolesId.producer, userData: getProducerData }} />}
          <div className="">
            <div className="medium_title">
              <h1 className="font-18 text-black">{lang?.Italian_F_and_B_producersB2B}</h1>
            </div>
            {producerSpinner ? (
              <FormSpinner />
            ) : (
              <div className="card--section site-align top-align flex-wrap">
                {getProducerData?.errors && (
                  <p>{getProducerData?.errors?.exception}</p>
                )}
                {getProducerData?.data?.data?.length > 0 && getProducerData?.data?.data.map((item, index) => {
                  return (
                    <div className="card card--block" key={index} >
                      <div className="hubUser">
                        <div className="feed-user-info">
                          <div className="user__pic" onClick={() => history.push(data?.user_data?.user_id === item.user_id ? "/profile" : `${"/visitor-profile"}/${item.user_id}`)}>
                            <img src={item.avatar_id && `${item.avatar_id.base_url}${item.avatar_id.attachment_medium_url}`} alt="User Image" />
                          </div>
                          <div className="user__detail-data">
                            <span className="user__name">
                              <Link to={data?.user_data?.user_id === item.user_id ? "/profile" : `${"/visitor-profile"}/${item.user_id}`} className="font-16 text-Blue">
                                {(item && item.first_name !== null && item && item.last_name !== null && `${item && item.first_name}${item && item.last_name}`) || (item && item.company_name) || (item && item.restaurant_name)}
                              </Link>
                              {/* <div className="flex"> */}
                              {/* </div> */}
                            </span>
                          </div>
                        </div>
                        {typeOfUser?.role_id !== constant.rolesId.voyagers && <div className="hub_btn flex items-center">
                          <div className={(data?.user_data?.user_id !== item.user_id && item?.hubConnectionRequest)? "md:w-1/2 viewReq mt-4" : "md:w-1/2 md:w-full viewReq mt-4"}><Link to={data?.user_data?.user_id === item.user_id ? "/profile" : `${"/visitor-profile"}/${item.user_id}`} className="btn bg-Primary bg-transparent w-full">{lang?.View}</Link></div>
                          {((userPercenatge === 100 && data?.user_data?.user_id !== item.user_id&& item?.hubConnectionRequest) && (item.available_to_connect === 1 && item.connection_flag === 0)) && <div className="md:w-1/2 view__hub__btn"><Link to="#" className="btn bg-Primary btn BgTeal w-full" onClick={() => handleConnectionModel(item)}>{lang?.Connect}</Link></div>}
                          {userPercenatge !== 100 && (<div className="md:w-1/2 view__hub__btn"><Link to="/home" className='btn bg-Primary btn BgTeal w-full'>{lang?.Connect}</Link></div>)}
                          {(item.available_to_connect === 1 && item.connection_flag === 2) && <div className="md:w-1/2 view__hub__btn"><Link to="#" onClick={() => { handleCancelReq(item.user_id, item.role_id) }} className='btn bg-Primary btn BgTeal w-full' >{lang?.Cancel}</Link></div>}
                          {(item.available_to_connect === 1 && item.connection_flag === 1) && <div className="md:w-1/2 view__hub__btn"><Link to="#" className='btn bg-Primary btn BgTeal w-full' >{lang?.Connected}</Link></div>}
                        </div>}
                        {parseInt(typeOfUser?.role_id) === constant.rolesId.voyagers && <div className="hub_btn flex items-center">
                          <div className={data?.user_data?.user_id !== item.user_id ? "md:w-1/2 viewReq mt-4" : "md:w-1/2 md:w-full viewReq mt-4"}><Link to={data?.user_data?.user_id === item.user_id ? "/profile" : `${"/visitor-profile"}/${item.user_id}`} className="btn bg-Primary bg-transparent w-full">{lang?.View}</Link></div>
                          {(item?.available_to_follow === 1 && item?.follow_flag === 0) && <div className="md:w-1/2 view__hub__btn"><Link to="#" className='btn bg-Primary btn BgTeal w-full' onClick={() => followUser(item)}>{lang?.Follow}</Link></div>}
                          {(item?.follow_flag === 1 && item?.available_to_follow === 1) && <div className="md:w-1/2 view__hub__btn"><Link to="#" className='btn bg-Primary btn BgTeal w-full' onClick={() => followUser(item)}>{lang?.Unfollow}</Link></div>}
                        </div>}
                      </div>
                      {/* <div className="card-form">
                              <div className="view__hub__btn">
                                <Link to="#">Pending</Link>
                              </div>
                            </div> */}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
          {isTrue && getProducerData?.data?.total > 10 &&
            <ReactPaginate
              previousLabel={"prev"}
              nextLabel={"next"}
              breakLabel={"..."}
              breakClassName={"break-me"}
              pageCount={Math.ceil((getProducerData?.data?.total) / (getProducerData?.data?.per_page))}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageClick}
              containerClassName={"pagination"}
              subContainerClassName={"pages pagination"}
              activeClassName={"active"}
              nextPageRel={'1'} />}
        </div>
        {/* Right Block */}
      </div>
    </div>
  );
}
